import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-non-null-asserted-optional-chain */
import { Box } from '@gemini/core';
import BlockTitle from '@/components/structure/BlockTitle';
import Container from '@/components/structure/Container';
import { usePrefixI18n, useRealEstate, } from '@/contexts/brandConfiguration/hooks';
import { useBreakpoint } from '@/hooks/useBreakpoints';
import { useTranslation } from '@/hooks/useTranslations';
import { RealEstateItem } from './RealEstateItem';
export const RealEstateListing = ({ pageConfiguration, landingType, }) => {
    var _a;
    const { t } = useTranslation();
    const config = useRealEstate(pageConfiguration, landingType);
    const prefix = usePrefixI18n();
    const locales = `${prefix}${pageConfiguration}.${landingType}.realestate`;
    const { isTablet, isMobile } = useBreakpoint();
    const isMinimized = isTablet || isMobile;
    const items = (_a = config === null || config === void 0 ? void 0 : config.items) === null || _a === void 0 ? void 0 : _a.map((item, index) => ({
        title: t(`${locales}.list.item${index + 1}.title`),
        description: item.description || '',
        illustration: item.illustration,
        number: isMinimized ? item.number.mobile : item.number.desktop,
        color: config.color,
        dashLine: isMinimized ? config === null || config === void 0 ? void 0 : config.dashLine.mobile : config === null || config === void 0 ? void 0 : config.dashLine.desktop,
        index,
    }));
    return (_jsxs(Container, { paddingVertical: {
            'breakpoint.base': 'spacing.16',
            'breakpoint.lg': 'spacing.80',
        }, paddingHorizontal: {
            'breakpoint.base': 'spacing.none',
            'breakpoint.lg': 'spacing.32',
        }, children: [_jsx(Box, { marginBottom: {
                    'breakpoint.base': 'spacing.32',
                    'breakpoint.lg': 'spacing.64',
                }, textAlign: "center", children: _jsx(BlockTitle, { as: "h2", children: t(`${locales}.title`) }) }), _jsx(Box, { display: "flex", flexDirection: "column", children: items === null || items === void 0 ? void 0 : items.map((item) => (_jsx(RealEstateItem, { item: item, isMinimized: isMinimized, isLast: item.index === items.length - 1 }, item.index))) })] }));
};
export default RealEstateListing;
